export default "__VITE_ASSET__JLWP$Scd__"